<script lang="ts">
  import type { AnimationConfig } from './types';
  import JumpingBubbles from './JumpingBubbles.svelte';
  import JumpingCheckmark from './JumpingCheckmark.svelte';

  export let config: AnimationConfig;
  export let scale: number = 1;
</script>

<div class="animation-container">
  {#if config.type === 'jumpingBubbles'}
    <JumpingBubbles {config} {scale} />
  {/if}
  {#if config.type === 'jumpingCheckmark'}
    <JumpingCheckmark 
      scale={scale} 
      color={config.color}
      duration={config.duration}
    />
  {/if}
</div>

<style>
  .animation-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style> 